// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__6KoJq","fade-in":"styles_fade-in__mIUCF"};